let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("fwbht"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("h5Eq0")]).then(() => parcelRequire('8IuF3'));